import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UtilService } from '../../services/util.service';
import { AccessGroup } from '@api/model/hardware/access-group';
import { tryGetGeolocation } from '@api/util/util';
import { CondoServiceV2 } from '@api/serviceV2/condo.service';
import { Condo } from '@api/model/condo';
import { SessionService } from '@api/service/session.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-select-access-group',
  templateUrl: 'modal-select-access-group.component.html',
  styleUrls: ['modal-select-access-group.component.scss']
})
export class ModalSelectAccessGroup {
  groups: AccessGroup[] = [];
  defaultGroup = null;

  callback: { success?: Function; error?: Function };

  condo: Condo;

  constructor(
    public bsModalRef: BsModalRef,
    public utilService: UtilService,
    private sessionService: SessionService,
    private condoService: CondoServiceV2,
    private toastr: ToastrService
  ) {
    this.defaultGroup = this.utilService.getLocalDefaultIncontrolGroup();
    this.condo = this.sessionService.condoValue;
  }

  async selectGroup(group: AccessGroup) {
    this.utilService.saveLocalDefaultIncontrolGroup(group._id);

    if (group.geolocation && this.condo?.latitude && this.condo?.longitude) {
      const geoData = await tryGetGeolocation(group.radius);

      if (geoData) {
        this.condoService.validateCondoGeolocation(this.condo.id, geoData).subscribe({
          next: res => {
            console.log(res);

            this.returnCallback(group);
          },
          error: err => {
            if (err.originalError?.message.includes('Distância maior do que a máxima permitida.')) {
              this.toastr.warning(
                'Por segurança, não é possível liberar visitantes enquanto estiver fora',
                'Ops! Parece que você não está no local no momento'
              );
            }
            console.warn(err);
          }
        });
      }
    } else {
      this.returnCallback(group);
    }
  }

  returnCallback(group) {
    if (this.callback) {
      this.callback.success(group);
    }

    this.bsModalRef.hide();
  }
}
